module.exports = __webpack_public_path__ + "static/media/pic2.7efcbd1d.jpg";